import { BunnyFolder } from "../Models/Bunny";

export const hostedImage = (path: string, folder: BunnyFolder) => {
  if (path.includes("http")) return path;
  if (path.length < 1) return ""
  
  return `${process.env.REACT_APP_MEDIA_CDN}${folder}/${path}`;
};
